// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Yej_","type":"styles_type__EIG2Q","choices":"styles_choices__ZPpfs"};